import { useMutation } from '@tanstack/vue-query'

function api() {
  return useApi('v1')
}

export async function hitUTMCount(payload: { utm: string }) {
  const response = await api().post('billing/hitutm', payload)
  return response
}

export function useHitUTMCount() {
  return useMutation({
    mutationFn: (payload: { utm: string }) => hitUTMCount(payload),
  })
}
